import React from 'react';
import NotFoundPage from '../pages/NotFoundPage';
import ServerErrorPage from '../pages/ServerErrorPage';
import ForbiddenPage from '../pages/ForbiddenPage';
import UnauthorizedPage from '../pages/UnauthorizedPage';
import NetworkErrorPage from '../pages/NetworkErrorPage';
import MaintenancePage from '../pages/MaintenancePage';
import ServiceUnavailablePage from '../pages/ServiceUnavailablePage';
import BadRequestPage from '../pages/BadRequestPage';

interface ErrorHandlerProps {
  statusCode?: number;
  errorType?: 'network' | 'maintenance' | 'default';
  error?: string;
}

const ErrorHandler: React.FC<ErrorHandlerProps> = ({ 
  statusCode, 
  errorType = 'default'
}) => {
  // Netzwerk-Fehler haben Priorität
  if (errorType === 'network') {
    return <NetworkErrorPage />;
  }

  // Wartungsseite hat Priorität
  if (errorType === 'maintenance') {
    return <MaintenancePage />;
  }

  // HTTP-Status-Code basierte Behandlung
  switch (statusCode) {
    case 400:
      return <BadRequestPage />;
    case 401:
      return <UnauthorizedPage />;
    case 403:
      return <ForbiddenPage />;
    case 404:
      return <NotFoundPage />;
    case 500:
      return <ServerErrorPage />;
    case 503:
      return <ServiceUnavailablePage />;
    default:
      // Fallback für unbekannte Fehler
      if (statusCode && statusCode >= 500) {
        return <ServerErrorPage />;
      } else if (statusCode && statusCode >= 400) {
        return <BadRequestPage />;
      }
      return <NotFoundPage />;
  }
};

export default ErrorHandler;
